import {DateTime} from 'luxon';
import {expandRecurring} from '../Calendar/recurrence';
import {eventsForAgendaDay} from '../Calendar/dayAgenda';

// A single hour scale keeps Overview's Events and Availability grids aligned.
export const OVERVIEW_DETAIL_HOUR_HEIGHT = 48;

export function overviewWeek(date,zone) {
  const day=DateTime.fromISO(date,{zone}).startOf('week');
  return Array.from({length:7},(_,index)=>day.plus({days:index}));
}

export function weekCalendarEvents(events,week) {
  const start=week[0].startOf('day'),end=week[week.length-1].endOf('day');
  const seen=new Set();
  // Expand far enough back to include an overnight (or longer) occurrence
  // beginning before Monday. Filter precisely in the selected zone afterwards.
  const lookBack=Math.max(86400000,...events.map(event=>Math.max(0,Date.parse(event.endUTC)-Date.parse(event.startUTC))||0));
  return expandRecurring(events.map(event=>({...event,calendar:event.calendar||'team'})),new Date(start.toMillis()-lookBack-86400000),end.plus({days:1}).toJSDate())
    .filter(event=>{
      const from=Date.parse(event.startUTC),to=Date.parse(event.endUTC);
      if((event.calendar!=='personal'&&(!event.__teamId||event.calendar!=='team'))||!Number.isFinite(from)||from>end.toMillis()||(Number.isFinite(to)&&to>from?to<=start.toMillis():from<start.toMillis()))return false;
      const key=JSON.stringify([event.calendar,event.__teamId,event.eventId||event.id,event.instanceDate||event.startUTC]);
      if(seen.has(key))return false;seen.add(key);return true;
    });
}

export function overviewDayEvents(events,day,zone) {
  return eventsForAgendaDay(events,new Date(day.year,day.month-1,day.day,12),zone);
}

// All weekly displays reserve the same equal-width day columns.
export function overviewWeekLayout() {
  return {'--schedule-week-columns':'var(--schedule-time-width) repeat(7,minmax(140px,1fr))','--schedule-grid-min':'1053px'};
}

export function overviewCalendarRoute(event,zone) {
  const date=DateTime.fromISO(event.startUTC,{zone}).toISODate();
  return '/home?view=events&'+new URLSearchParams({teamId:event.__teamId,calendarTeam:event.__teamId,calendarDate:date,calendarTimeZone:zone});
}
